export const TAGS_PROJECT_TAB_ID = 1
export const TAGS_REQUESTS_TAB_ID = 3

export const TAGS_TABS = [
  {
    id: TAGS_PROJECT_TAB_ID,
    title: 'Project list tags',
    defaultTab: true
  },
  {
    id: 2,
    title: 'Vendor tags'
  },
  {
    id: TAGS_REQUESTS_TAB_ID,
    title: 'List of Request tags'
  }
]



// WEBPACK FOOTER //
// ./src/constants/Tabs/Tags.js